/*
 * Created on Wed Nov 01 2023 4:27:51 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import React from "react";
import {
  ArrowRight,
  Building2,
  GraduationCap,
  ShoppingBag,
  Sparkles,
  Users,
  ChevronRight,
  Globe,
  Heart,
  Target,
  TrendingUp,
  Shield,
  Star,
  Zap,
  CheckCircle,
} from "lucide-react";

const iconMap = {
  ArrowRight,
  Building2,
  GraduationCap,
  ShoppingBag,
  Sparkles,
  Users,
  ChevronRight,
  Globe,
  Heart,
  Target,
  TrendingUp,
  Shield,
  Star,
  Zap,
  CheckCircle,
};

/**
 * Resolves an icon name string to a Lucide React component element.
 * @param {string} name - Icon name matching lucide-react export
 * @param {object} props - Props to pass to the icon component (e.g. className)
 * @returns {JSX.Element|null}
 */
export const getIcon = (name, props = {}) => {
  const IconComponent = iconMap[name];
  if (!IconComponent) return null;
  return <IconComponent {...props} />;
};

export default iconMap;